import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'htmlEntityDecode',
})
export class HtmlEntityDecodePipe implements PipeTransform {
  public transform(value: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }
}
